import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

import imgIconCircleFan from '../images/icons/i-circle-fan.svg';

const LoadingContainer = styled.div`
  z-index: 2000;
`;

const loadingAnimation = keyframes`
  0%,
  2% {
    transform: rotate(0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  50% {
    transform: rotate(-1080deg);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  98%,
  100% {
    transform: rotate(-2160deg);
  }
`;

const LoadingDiv = styled.img`
  position: relative;
  display: inline-block;
  animation: ${loadingAnimation} 1800ms infinite;
`;

const setAppScroll = (value) => {
  document.body.style.overflow = value;
};

const Loading = ({ show }) => {
  useEffect(() => {
    if (show) setAppScroll('hidden');
    else setAppScroll('auto');
  }, [show]);

  return show ? (
    <LoadingContainer className="flex justify-center items-center flex-col fixed top-0 bottom-0 left-0 right-0 bg-black bg-opacity-20 select-none">
      <div className="flex justify-center items-center flex-col bg-black bg-opacity-50 rounded-full w-32 h-32 xs:w-36 xs:h-36 sm:w-40 sm:h-40 md:w-44 md:h-44 lg:w-48 lg:h-48">
        <LoadingDiv
          className="w-12 h-12 xs:w-14 xs:h-14 sm:w-16 sm:h-16 lg:w-20 lg:h-20 mb-4 drop-shadow-sm"
          src={imgIconCircleFan}
        />
        <h2 className="font-bold text-white text-sm xs:text-base">載入中...</h2>
      </div>
    </LoadingContainer>
  ) : (
    <></>
  );
};

Loading.propTypes = {
  show: PropTypes.bool,
};

export default Loading;
